import React, { useState, useEffect } from "react";
import Cookies from "js-cookie";
import Form, { Field } from "rc-field-form";
import Message from "rc-message";
import style from "./loginbox.module.css";
import axios from "../../utils/request";
import md5 from "md5";
import Input from "../inputLogin";

const Error = ({ children }) => (
  <ul style={{ color: "#E02020", position: "absolute", fontSize: "12px" }}>
    {children.map((error) => (
      <li
        key={error}
        style={{
          marginLeft: "0",
          borderTop: "1px solid #E02020",
          width: "28.4083vw",
        }}
      >
        {error}
      </li>
    ))}
  </ul>
);

export default function LoginBox(props) {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [mode, setMode] = useState(false);
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    setMounted(true);
  }, []);

  function handleClose() {
    setMode(false);
    props.hideFn(false);
  }

  return (
    <div
      style={{ display: mounted ? "block" : "none" }}
      className={style.loginBox}
    >
      {props.isShowLogin && (
        <div className={style.shade} onClick={handleClose}></div>
      )}
      <div
        className={`${style.loginWrap} ${
          props.isShowLogin ? style.loginRight : style.loginBack
        }`}
      >
        <span className={style.closeButton} onClick={handleClose}>
          <img
            width="40"
            height="40"
            src={require("../../img/icon_close.png")}
            alt="关闭"
          />
        </span>
        {!mode && (
          <>
            <h1>产品出版社</h1>
            <Form
              form={form}
              autoComplete="false"
              onFinish={async (values) => {
                values.password = md5(values.password.trim()).toString();
                setLoading(true);
                const { data } = await axios({
                  method: "post",
                  headers: { "Content-Type": "application/json;charset=UTF-8" },
                  url: "/designer/login",
                  data: values,
                });
                setLoading(false);
                if (data?.success) {
                  Cookies.set("token", data.token, { expires: 1 });
                  Cookies.set("userId", data.userId, { expires: 1 });
                  const { data: userData } = await axios({
                    method: "get",
                    headers: {
                      "Content-Type": "application/json;charset=UTF-8",
                    },
                    url: "/designer/userinfo",
                  });
                  if (
                    userData.status === 0 ||
                    (userData.status === 1 && userData.contractStatus === 9) ||
                    userData.status === 2
                  ) {
                    window.open("/designerPress/verify", "_blank");
                    // navigateTo("/designerPress/verify");
                  }
                  if (userData.contractStatus === 0) {
                    window.open("/designerPress/contract", "_blank");
                    // navigateTo("/designerPress/contract");
                  }
                  if (
                    userData.contractStatus === 1 && userData.jointInfoStatus === 0
                  ) {
                    window.open("/designerPress/jointInfo", "_blank");
                    // navigateTo("/designerPress/jointInfo");
                  }
                  if (
                    userData.contractStatus === 1 &&
                    userData.profileStatus === 0 && userData.jointInfoStatus === 1
                  ) {
                    window.open("/designerPress/fullInfo", "_blank");
                    // navigateTo("/designerPress/fullInfo");
                  }
                  if (userData.profileStatus === 1) {
                    window.open("/designerPress/designerIndex", "_blank");
                    // navigateTo("/designerPress/designerIndex");
                  }
                } else {
                  Message.warning({
                    content: data.msg,
                  });
                }
              }}
            >
              {(values, form) => {
                const accountError = form.getFieldError("account");
                const passwordError = form.getFieldError("password");

                return (
                  <React.Fragment>
                    <Field
                      name="account"
                      rules={[{ required: true, message: "请输入手机号" }]}
                    >
                      <Input placeholder="请输入手机号" autoComplete="false" />
                    </Field>
                    <Error>{accountError}</Error>

                    <Field
                      name="password"
                      rules={[{ required: true, message: "请输入密码" }]}
                    >
                      <Input
                        placeholder="请输入密码"
                        autoComplete="new-password"
                        type="password"
                      />
                    </Field>
                    <Error>{passwordError}</Error>
                    {/* <a href="" className={style.forgetButton}>
                        忘记了密码？
                      </a> */}
                    <button
                      className={`${style.registerButton} ${
                        loading ? style.grey : ""
                      }`}
                      disabled={loading}
                    >
                      {loading ? (
                        <>
                          <img
                            width="640"
                            height="360"
                            src={require("../../img/icon_loading.png")}
                            alt="加载"
                          />
                          登录中
                        </>
                      ) : (
                        "登录"
                      )}
                    </button>
                  </React.Fragment>
                );
              }}
            </Form>

            <div className={style.joinBox}>
              <h2>加入ICY产品出版社</h2>
              <p>
                如果您还不是产品出版社的设计师，请在此注册。
                <br />
                请您提供我们一些必要信息
                <span onClick={() => setMode(true)}>了解合作模式</span>
              </p>
              <a onClick={() => window.open("/designerPress/register", "_blank")} className={style.registerButton}>
                立即入驻
              </a>
            </div>
          </>
        )}

        {mode && (
          <div className={style.modeWrap}>
            <img
              width="56"
              height="56"
              onClick={() => setMode(false)}
              className={style.backArrow}
              src={require("../../img/back_arrow.png")}
              alt="返回"
            />
            <h3>ICY 设计师“产品出版社”合作模式</h3>
            <p>
              ICY&设计师联名，通过数字化手段赋能设计师产品，帮助设计师拓宽产品价格带，推动设计师品牌商业化。ICY作为全球设计师“产品出版社”，采取“销售分成”的方式与设计师合作，设计师提供好的设计，ICY提供规模化的供应链体系和数据化的供给配置系统，让好设计变成好产品；打通线上线下多元化的零售场景，将好产品变成好商品；并通过ICY全球博主营销体系，让设计师产品被大众消费者所熟知。
            </p>
          </div>
        )}
      </div>
    </div>
  );
}
